export const GET_NOTES_LOADING = "get/notes/loading"
export const GET_NOTES_SUCCESS = "get/notes/success"
export const GET_NOTES_ERROR = "get/notes/error"

export const CREATE_NOTES_LOADING = "create/notes/loading"
export const CREATE_NOTES_SUCCESS = "create/notes/success"
export const CREATE_NOTES_ERROR = "create/notes/error"

export const UPDATE_NOTES_LOADING = "update/notes/loading"
export const UPDATE_NOTES_SUCCESS = "update/notes/success"
export const UPDATE_NOTES_ERROR = "update/notes/error"

export const DELETE_NOTES_LOADING = "delete/notes/loading"
export const DELETE_NOTES_SUCCESS = "delete/notes/success"
export const DELETE_NOTES_ERROR = "delete/notes/error"